@if (status === 'overdue') {
<mat-icon class="overdue-icon" [title]="'InvoiceOverdueLabel' | translate" [attr.aria-label]="'InvoiceOverdueLabel' | translate">error</mat-icon>
} @else if (status === 'dueSoon') {
<mat-icon class="due-soon-icon" [title]="'InvoiceDueSoonLabel' | translate" [attr.aria-label]="'InvoiceDueSoonLabel' | translate">schedule</mat-icon>
} @if (invoiceNumber) { @if (canSeeInvoiceDetails) {
<a href="javascript:void(0)" class="invoice-link">{{ invoiceNumber }}</a>
} @else {
<span class="theme-table-row">{{ invoiceNumber }}</span>
} }
